<template>
  <v-dialog v-model="dialog" persistent width="500px">
    <v-card>
      <v-card-title> Selecionar Marca </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <BrandsSearch label="" v-model="form.brand" ref="BrandsSearch" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="dialog = false"> Cancelar </v-btn>
        <v-btn color="primary" @click="confirm()"> Confirmar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BrandsSearch from "@/components/brands/ui/BrandsSearch.vue";
export default {
  components: { BrandsSearch },

  data() {
    return {
      dialog: false,

      baseForm: {
        brand: null,
        stock_audit: {},
      },
      form: {},
    };
  },

  methods: {
    async open(stock_audit) {
      this.reset();
      this.form.stock_audit = stock_audit;
      this.dialog = true;
    },

    reset() {
      this.form = JSON.parse(JSON.stringify(this.baseForm));
    },

    async confirm() {
      this.$loading.start();
      await this.$http
        .store("stock/start-stock-audit", {
          stock_audit: this.form.stock_audit,
          brand_id: this.form.brand.id,
        })
        .then(async (response) => {
          this.$emit("store");
          this.$loading.finish();
          this.dialog = false;
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style>
</style>